<template>
  <!-- content start -->
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      minHeight: '100vh',
      height: 'auto',
      paddingBottom: '10px'
    }"
  >
    <OverlappedHeader :model="headerData" />
    <div
      style="margin-left: 15px;margin-right: 15px; margin-top: -175px; padding: 10px; margin-bottom: 10px; border-radius: 15px; min-height: 100vh;"
      :style="{
        backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
      }"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
        }"
        style="border-bottom-left-radius: 10px !important;
        border-bottom-right-radius: 10px !important; padding: 1px 10px
        !important;"
        class="history-section common-block"
        v-if="historyData.length > 0"
      >
        <div
          v-for="(item, index) in historyData"
          :class="['live-quiz history-block']"
          style="align-items:center; border-bottom: 1px solid #000000 !important; padding-right: 0px !important;"
          v-on:click="showLeaderboard(item)"
        >
          <div style="display: flex; ">
            <div class="date">
              <p style=" width: 48px ; height:43px ">
                <span
                  style="font-size: 6px;"
                  :style="{
                    backgroundColor: isDarkTheme ? topBgColor : bgTheme,
                    color: isDarkTheme ? headingTextColor : '#ffffff'
                  }"
                  >{{ formatISODateString(item.created_at)[1] }}
                  {{ formatISODateString(item.created_at)[2] }}</span
                >
                {{ formatISODateString(item.created_at)[0] }}
              </p>
            </div>
            <div
              class="detail"
              style="text-align: left;margin: 0.4rem 0 !important"
            >
              <p style="margin: 0px!important;">{{ item.title }}</p>

              <span style="color: #585957; font-size: 12px;">
                {{ formatTime(item.start_time) }} -
                {{ formatTime(item.end_time) }}
              </span>
            </div>
          </div>
          <div v-if="!item.is_live" class="arr-class">
            <img class="super-small-icon" src="@/assets/right-arrow.svg" />
          </div>
          <div>
            <div v-if="item.is_live" class="live">
              Live
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="historyData.length === 0"
        class="height-90 border-radius-5 align-ver center-hor"
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
        }"
      >
        <div
          style="display: flex; justify-content: center; align-items: center; width: 100%"
        >
          <img src="@/assets/no-data.svg" class="w20" style="width: 20%;" />
        </div>
        <div class="font-bold">No History Found!!</div>
      </div>
    </div>

    <div
      id="toast"
      class="font-bold pos-fixed pos-center-hor pull-down"
      style="width: 80%;
        padding: 15px 5px 5px 5px; border-radius: 40px; background: #000000;
        margin-bottom: 70px; color: white; display: none; z-index: 999;
        position: fixed;bottom: 0px; height: 30px;"
    ></div>
    <infinite-loading @infinite="fetchQuizHistory" ref="infiniteLoading"
      ><span slot="no-more"></span
    ></infinite-loading>
  </div>
  <!-- content end -->
</template>

<script>
// import Tasks from '../components/Tasks'
import QuizHeader from "@/components/quiz-header";
import OverlappedHeader from "../components/overlapped-header.vue";
import axios from "axios";
export default {
  name: "quiz-history",
  components: {
    QuizHeader,
    OverlappedHeader
  },
  data: () => ({
    historyData: [],
    page: 1,
    headerData: {
      onlyHeader: true
    }
  }),
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    bgTheme() {
      return this.$store.state.bg_theme;
    }
  },
  // Replace your methods and lifecycle hooks with these:

  methods: {
    formatTime(time) {
      if (!time) return "";

      let [hour, minute] = time.split(":").map(Number);
      let ampm = hour >= 12 ? "PM" : "AM";

      hour = hour % 12;
      hour = hour ? hour : 12; // 0 becomes 12

      return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`;
    },

    showLeaderboard(item) {
      if (item.is_live) {
        document.getElementById("toast").innerHTML =
          "Quiz is LIVE. Please check later";
        document.getElementById("toast").style.display = "block";
        setTimeout(function() {
          document.getElementById("toast").style.display = "none";
        }, 30000);
      } else {
        this.$store.state.quizDetailsTitle = item.title;
        this.$router.push({
          name: "leadboard",
          params: { id: item.id, title: item.title }
        });
      }
    },

    formatISODateString(dateStr) {
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = date.toLocaleString("default", { month: "short" });
      var dt = date.getDate();

      if (dt < 10) {
        dt = "0" + dt;
      }

      return [dt, month, year];
    },

    fetchQuizHistory($state) {
      const url = this.$store.getters.flyyDomain + "/v1/quiz_history";
      const headers = this.$store.getters.headers;

      axios
        .get(url, {
          headers,
          params: { page: this.page }
        })
        .then(resp => {
          if (resp.status === 200) {
            const tournaments = resp.data.tournaments;

            if (tournaments && tournaments.length) {
              // Append data to existing array
              this.historyData.push(...tournaments);

              // ✔ increment AFTER processing
              this.page++;

              if ($state) $state.loaded();
            } else {
              if ($state) $state.complete();
            }
          } else {
            if ($state) $state.error();
          }
        })
        .catch(() => {
          if ($state) $state.error();
        });
    },

    // ✅ Load initial data (page 1) directly
    loadInitialData() {
      const url = this.$store.getters.flyyDomain + "/v1/quiz_history";
      const headers = this.$store.getters.headers;

      axios
        .get(url, {
          headers,
          params: { page: 1 }
        })
        .then(resp => {
          if (resp.status === 200) {
            const tournaments = resp.data.tournaments;
            if (tournaments && tournaments.length) {
              this.historyData = tournaments;
              this.page = 2; // Set to page 2 for next infinite scroll load
            }
          }
        })
        .catch(error => {
          console.error("Error loading initial quiz history:", error);
        });
    }
  },

  created() {
    this.$store.state.quizDetailsTitle = "Leaderboard";
    this.$store.state.headTitle = "Leaderboard";

    // ✅ Load page 1 immediately when component is created
    this.loadInitialData();
  },

  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

.arr-class {
  position: absolute;
  right: 0px;
  top: 50%;
  padding-left: 10px;
  font-family: "Montserrat", sans-serif;
  font-size: 9px;
  line-height: 10px;
  text-transform: uppercase;
  color: #373535;
  transform: translate(0, -50%);
}
</style>
